module.exports = __webpack_public_path__ + "static/media/layer2.aae23d87.svg";